import React, { createContext, useContext, useState } from 'react';
import { createTheme } from '@mui/material/styles';

// Import themes
import themeDefault from '../theme';
import themeDark from '../theme-dark';

const themes = {
  light: themeDefault,
  dark: themeDark,
};

const ThemeContext = createContext();

export const ThemeProviderWrapper = ({ children }) => {
  const [themeName, setThemeName] = useState('light');
  const activeTheme = themes[themeName];

  const switchTheme = () => {
    setThemeName(prev => prev === 'light' ? 'dark' : 'light');
  };

  const value = {
    themeName,
    switchTheme,
    activeTheme,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProviderWrapper');
  }
  return context;
}; 